export default __webpack_public_path__ + "static/media/text.33c7c1d0.svg";